// extracted by mini-css-extract-plugin
module.exports = {"marker":"CurrentLocationMarker_marker__1ZY99"};